import { c as _c } from "react/compiler-runtime";
import type { L10n } from '@onefootprint/core';
import { Button, Form } from '@onefootprint/ui';
import { FormProvider, useForm } from 'react-hook-form';
type PhoneFormData = {
  phoneNumber: string;
};
type PhoneFormProps = {
  defaultPhone?: string;
  isLoading?: boolean;
  l10n?: L10n;
  onSubmit: (formData: PhoneFormData) => void;
  validator?: (phone: string) => boolean;
  texts: {
    cta: string;
    phoneInvalid: string;
    phoneLabel: string;
    phoneRequired: string;
  };
};
const PhoneForm = t0 => {
  const $ = _c(26);
  const {
    defaultPhone,
    isLoading,
    l10n,
    onSubmit,
    texts,
    validator
  } = t0;
  let t1;
  if ($[0] !== defaultPhone) {
    t1 = {
      defaultValues: {
        phoneNumber: defaultPhone
      }
    };
    $[0] = defaultPhone;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const methods = useForm(t1);
  let t2;
  if ($[2] !== methods || $[3] !== onSubmit || $[4] !== texts.phoneInvalid || $[5] !== validator) {
    t2 = formData => {
      if (validator && !validator(formData.phoneNumber)) {
        methods.setError("phoneNumber", {
          message: texts.phoneInvalid
        }, {
          shouldFocus: true
        });
        return;
      }
      onSubmit(formData);
    };
    $[2] = methods;
    $[3] = onSubmit;
    $[4] = texts.phoneInvalid;
    $[5] = validator;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const handleBeforeSubmit = t2;
  let t3;
  if ($[7] !== handleBeforeSubmit || $[8] !== methods) {
    t3 = methods.handleSubmit(handleBeforeSubmit);
    $[7] = handleBeforeSubmit;
    $[8] = methods;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const t4 = l10n?.locale;
  let t5;
  if ($[10] !== texts.phoneRequired) {
    t5 = {
      required: texts.phoneRequired
    };
    $[10] = texts.phoneRequired;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5 || $[14] !== texts.phoneLabel) {
    t6 = <Form.Tel autoFocus={true} data-nid-target="phone-number" label={texts.phoneLabel} locale={t4} name="phoneNumber" rules={t5} />;
    $[12] = t4;
    $[13] = t5;
    $[14] = texts.phoneLabel;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== isLoading || $[17] !== texts.cta) {
    t7 = <Button fullWidth={true} loading={isLoading} type="submit" size="large" data-dd-action-name="phone:continue">{texts.cta}</Button>;
    $[16] = isLoading;
    $[17] = texts.cta;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t3 || $[20] !== t6 || $[21] !== t7) {
    t8 = <form className="grid gap-6" onSubmit={t3}>{t6}{t7}</form>;
    $[19] = t3;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== methods || $[24] !== t8) {
    t9 = <FormProvider {...methods}>{t8}</FormProvider>;
    $[23] = methods;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};
export default PhoneForm;